<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
        :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>

            <a-descriptions-item label="消息标题">{{ form.title }}</a-descriptions-item>
            <a-descriptions-item label="发布时间">{{form.publishTime}}</a-descriptions-item>
            <a-descriptions-item label="内容">
              <span v-html="form.content"></span>
            </a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
import { formMixin } from "@/mixins";

export default {
    name: "Detail",
    mixins: [formMixin],
    components:{},
    data() {
        return {
            form: {
                id: null,
                title: null,
                content: null,

            },
        }
    },
    methods:{
        onClose(){
            this.visible = false
            this.$emit("onCloseModel")
        }
    }
}
</script>

<style scoped lang="less">

</style>
